import SiteLayout from "@/components/feature/SiteLayout";
import { Link } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import CoreBusinessSection from "./components/CoreBusinessSection";
import RollPressHighlightSection from "./components/RollPressHighlightSection";
import ProductCategorySection from "./components/ProductCategorySection";
import EngineeringServiceSection from "./components/EngineeringServiceSection";
import IndustriesSection from "./components/IndustriesSection";
import CTASection from "@/components/feature/CTASection";

const APP_EXAMPLES = [
  "Battery Electrode Roll Press",
  "Film Roll Press",
  "Paper Roll Press",
  "Industrial Roll-to-Roll Press System",
  "Precision Press Control System",
];

export default function Home() {
  return (
    <SiteLayout navVariant="transparent">
      <HeroSection />
      <CoreBusinessSection />
      <RollPressHighlightSection />
      <ProductCategorySection />
      <EngineeringServiceSection />
      <IndustriesSection />

      {/* Application Examples — Roll Press */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
              <span className="w-6 h-px bg-accent-500" />
              Application Examples
              <span className="w-6 h-px bg-accent-500" />
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950">
              적용 예시
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
            {APP_EXAMPLES.map((a, i) => (
              <div
                key={a}
                className="bg-background-50 border border-background-200 rounded-lg p-5 text-center hover:border-primary-300 transition-colors"
              >
                <div className="text-[11px] font-semibold tracking-[0.2em] uppercase text-secondary-600 mb-2">
                  CASE {String(i + 1).padStart(2, "0")}
                </div>
                <div className="text-sm font-bold text-foreground-950 leading-snug">
                  {a}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 flex justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center" />
              우리 라인에 맞는 Roll Press 제어 문의하기
            </Link>
          </div>
        </div>
      </section>

      <CTASection />
    </SiteLayout>
  );
}